exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.headerText[data-v-b08008f4] {\n    color: rgba(0, 0, 0, 0.6);\n    font-size: 14px;\n    font-weight: 500;\n}\n", ""]);
